import { Component } from '@angular/core'
import { TranslocoModule } from '@jsverse/transloco'

@Component({
   selector: 'app-user',
   standalone: true,
   imports: [TranslocoModule],
   templateUrl: './user.component.html'
})
export class UserComponent {

}
